import erweima from "@/assets/images/erweima.png";
export default function () {
    const baseUrl = "https://apaas-static.oss-cn-beijing.aliyuncs.com";
    return {
        system: {
            logo: {
                default: `${baseUrl}/logo-cloud.png`,
                cscec: `${baseUrl}/logo-cscec.png`
            },
            logoGreen: `${baseUrl}/logo_green.png`,
            boy: `${baseUrl}/boy.png`
        },
        login: {
            loginBg: {
                default: `${baseUrl}/login/loginBg-apaas.jpg`,
                cscec: `${baseUrl}/login/loginBg-cscec.jpg`
            },
            wechat: `${baseUrl}/login/wechat.png`
        },
        aboutUs: {
            work: `${baseUrl}/aboutUs/work.png`,
            mask: `${baseUrl}/aboutUs/mask.png`,
            plat: `${baseUrl}/aboutUs/plat.png`,
            platIcon1: `${baseUrl}/aboutUs/plat-icon1.png`,
            platIcon2: `${baseUrl}/aboutUs/plat-icon2.png`,
            fun: `${baseUrl}/aboutUs/fun.png`,
            funIcon1: `${baseUrl}/aboutUs/fun-icon1.png`,
            funIcon2: `${baseUrl}/aboutUs/fun-icon2.png`,
            funIcon3: `${baseUrl}/aboutUs/fun-icon3.png`,
            funIcon4: `${baseUrl}/aboutUs/fun-icon4.png`,
            funIcon5: `${baseUrl}/aboutUs/fun-icon5.png`,
            funIcon6: `${baseUrl}/aboutUs/fun-icon6.png`,
            funIcon7: `${baseUrl}/aboutUs/fun-icon7.png`,
            product: `${baseUrl}/aboutUs/product.png`,
            productIcon1: `${baseUrl}/aboutUs/product-icon1.png`,
            productIcon2: `${baseUrl}/aboutUs/product-icon2.png`,
            productIcon3: `${baseUrl}/aboutUs/product-icon3.png`,
            team: `${baseUrl}/aboutUs/team.png`,
            teamIcon: `${baseUrl}/aboutUs/team-icon1.png`

        },
        company: {
            userLine: `${baseUrl}/company/userLine.png`,
            adminTag: `${baseUrl}/company/admintag.png`,
            noMessage: `${baseUrl}/company/noMessage.png`
        },
        app: {
            document: `${baseUrl}/app/document.png`,
            finance: `${baseUrl}/app/finance.png`,
            manpower: `${baseUrl}/app/manpower.png`,
            meeting: `${baseUrl}/app/meeting.png`,
            performance: `${baseUrl}/app/performance.png`,
            nocompany: `${baseUrl}/app/nocompany.png`,
            addapp: `${baseUrl}/app/addapp.png`,
            uploadapp: `${baseUrl}/app/uploadapp.png`,
            modelapp: `${baseUrl}/app/modelapp.png`,
            nodata: `${baseUrl}/app/nodata.png`,
            upload: `${baseUrl}/app/upload.png`,
            clock: `${baseUrl}/flow/clock.png`,
            help: `${baseUrl}/app/help.png`,
            join: `${baseUrl}/app/join.png`,
            custom: `${baseUrl}/app/custom.png`
        },
        mod: {
            editor: `${baseUrl}/mod/editor.jpg`,
            erweima // 待替换为icon，不用上传oss
        },
        flow: {
            notify: `${baseUrl}/flow/notify.png`,
            submit: `${baseUrl}/flow/submit.png`,
            subflow: `${baseUrl}/flow/subflow.png`,
            userStart: `${baseUrl}/flow/userStart.png`,
            verify: `${baseUrl}/flow/verify.png`
        },
        FileArchive: {
            documentGroup: `${baseUrl}/FileArchive/document_group.png`
        },
        fileType: {
            doc: `${baseUrl}/fileType/doc.png`,
            excel: `${baseUrl}/fileType/excel.png`,
            pdf: `${baseUrl}/fileType/pdf.png`,
            ppt: `${baseUrl}/fileType/ppt.png`,
            rar: `${baseUrl}/fileType/rar.png`,
            text: `${baseUrl}/fileType/text.png`,
            zip: `${baseUrl}/fileType/zip.png`,
            other: `${baseUrl}/fileType/other.png`
        }
    };
}



// WEBPACK FOOTER //
// ./src/data/system/imageSrcMap.js